var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadCv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6177 7.15627L11.9148 6.35627C11.7207 6.13547 11.3847 6.11413 11.1628 6.3072L9.06679 8.144V0.533333C9.06679 0.238933 8.82786 0 8.53346 0H7.46679C7.17239 0 6.93346 0.238933 6.93346 0.533333V8.144L4.83746 6.3072C4.61666 6.11413 4.28066 6.13547 4.08546 6.35627L3.38253 7.1552C3.18733 7.37707 3.20973 7.7152 3.43159 7.90933L7.64919 11.6011C7.85079 11.7771 8.15053 11.7771 8.35213 11.6011L12.5687 7.90933C12.7905 7.7152 12.8129 7.37707 12.6177 7.15627Z",
    fill: "#929292"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8668 13.8672H2.13343C1.83903 13.8672 1.6001 14.1061 1.6001 14.4005V15.4672C1.6001 15.7616 1.83903 16.0005 2.13343 16.0005H13.8668C14.1612 16.0005 14.4001 15.7616 14.4001 15.4672V14.4005C14.4001 14.1061 14.1612 13.8672 13.8668 13.8672Z",
    fill: "#929292"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCv);
export default __webpack_public_path__ + "static/media/download-cv.dae510fe.svg";
export { ForwardRef as ReactComponent };